export default __webpack_public_path__ + "static/media/quiz-banner.6d28103e.png";